import React, { useEffect,useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import CircularProgress from "@mui/material/CircularProgress";

export default function DeleteModal(props) {
const {deleteModalOpen, setDeleteModalOpen,confirmDelete,setConfirmDelete,deleteLoading} = props;

useEffect(()=>{
    if (!deleteLoading && confirmDelete) {
        setDeleteModalOpen(false)
    }
},[deleteLoading])

  return (
    <Dialog
      open={deleteModalOpen}
      // onClose={() => handleClose(false)}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
        Are you sure you want to delete ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {setConfirmDelete(false),setDeleteModalOpen(false)}} variant="outlined" color="primary">
          No
        </Button>
        {deleteLoading ?  <CircularProgress sx={{ color: "blue", marginLeft: "5%" }} />:
        <Button onClick={() => {setConfirmDelete(true)}} color="primary" autoFocus style={{ backgroundColor: '#010160', color: 'white' }}>
           Yes
        </Button>}
      </DialogActions>
    </Dialog>
  );
}


